<tt-page *ngIf="!!copy">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="order_order_no" [ttModel]="copy.order_order_no" ttReadonly></tt-input>
        <tt-search ttLabel="stat_cust_name" [(ttModel)]="copy.stat_cust_name" [ttSearch]="searchStatCustNames" (ttOnSelected)="onStatCustNameSelected($event)" (ttOnClear)="onStatCustNameSelected()"></tt-search>
        <tt-checkbox ttLabel="reverse_quantity" [(ttModel)]="copy.reverse_quantity"></tt-checkbox>
        <tt-select ttLabel="ordertype_id_new" [(ttModel)]="copy.ordertype_id_new" [ttData]="selectListOrderTypes" ttDataId="ordertype_id" ttDataName="ordertype_name"></tt-select>
        <tt-checkbox ttLabel="update_price_from_pricelist" [(ttModel)]="copy.update_price_from_pricelist"></tt-checkbox>
        <tt-button ttText="orderheadcopy_copy" (ttClick)="copyChanges()" [ttSpin]="copying" ttIcon="fas fa-sync"></tt-button>
        <tt-button-settings *ngIf="copy.show_setting === '1'"></tt-button-settings>
    </tt-card>
</tt-page>
